import {AppService} from "../typescript/app/app.service";
import {PageResponse} from "../typescript/util/page-response";
import {InfluenciaCompra} from "./influencia-compra";

class InfluenciacompraService {

    static API_URL = "/api/influenciacompras/v2";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<InfluenciaCompra>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            descricao: sort?.startsWith('descricao') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }

    static save(item: InfluenciaCompra) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createInfluenciacompra() {
        const influenciaCompra: InfluenciaCompra = {
            descricao: ''
        }
        return influenciaCompra;
    }
}

export {InfluenciacompraService};